import { YOUTH_DIVISIONS } from 'constants/event';

export const isYouthEvent = (eventRank) => {
  return YOUTH_DIVISIONS.includes(eventRank);
};
